import { useParams } from "react-router-dom";
import { EditUserContainer } from "./container";

export const EditUserPane = (props: {}) => {
  const params = useParams();
  const { userId } = params;
  if (userId === undefined) return null;
  return <EditUserContainer userId={userId} />;
};
